import { DEFAULT_METRIC_WINDOW, METRIC_WINDOWS, type MetricWindow } from "@/api";

/**
 * 조회 창의 URL 코덱과 한국어 라벨이다.
 *
 * URL 에는 **wire 값을 그대로** 남긴다(`?window=7d`). 한국어 라벨을 URL 에 넣지 않는 이유는
 * `docs/rules.md` §17 이 상대 기간을 프리셋 키로 남기라고 정한 이유와 같다. 표기 문구가 바뀌어도
 * 공유한 링크는 계속 동작해야 한다. 또한 서버가 받는 값과 링크의 값이 같아야 대조할 수 있다.
 *
 * 창은 **페이지 전역 축 하나**다. 탭마다 다른 창을 두면 탭을 옮길 때마다 구간이 바뀐다. 그러면
 * 같은 사고를 여러 지표로 대조하는 이 화면의 목적을 이룰 수 없다.
 *
 * Owns: 창 URL 파라미터 키, 정규화, 표시 라벨.
 * Does not own: 창 어휘 자체와 기본값. 서버 계약이라 `@/api` 가 소유한다.
 */

export const OBSERVABILITY_WINDOW_PARAM = "window";

const WINDOW_LABELS: Record<MetricWindow, string> = {
  "1h": "최근 1시간",
  "6h": "최근 6시간",
  "24h": "최근 24시간",
  "7d": "최근 7일",
  "30d": "최근 30일",
};

/** 어휘 밖의 값은 서버 기본값으로 바꾼다. 그대로 보내면 서버가 422 를 준다. */
export function normalizeMetricWindow(value: string | null): MetricWindow {
  return METRIC_WINDOWS.includes(value as MetricWindow)
    ? (value as MetricWindow)
    : DEFAULT_METRIC_WINDOW;
}

export function metricWindowLabel(window: MetricWindow): string {
  return WINDOW_LABELS[window];
}

/** facet 드롭다운 선택지다. 어휘 순서(짧은 창 → 긴 창)를 그대로 쓴다. */
export const metricWindowOptions: readonly { value: MetricWindow; label: string }[] =
  METRIC_WINDOWS.map((window) => ({ value: window, label: WINDOW_LABELS[window] }));
